import { ROLE, type Role } from '../contexts/CustomerHubContext'

type PassportClient = 'CustomerRTW' | 'SuitsupplyRTW'

export function getPassportClientForRole(role?: Role): PassportClient {
  return role === ROLE.CUSTOMER ? 'CustomerRTW' : 'SuitsupplyRTW'
}
